// @ts-expect-error
import type { SearchResult } from '@shared/dream-components';
import { SearchModalElement } from '@shared/dream-components';
import { useEffect, useState } from 'react';
import { ClientOnly } from 'remix-utils/client-only';

import useGlobalModals from '~/components/GlobalModals/hooks/useGlobalModals';

import usePaginatedPosts from '~/hooks/usePaginatedPosts';

const DEFAULT_POSTS_PER_PAGE = 20;

const SearchModal = () => {
  const { handleCloseModal, handleOpenModal, currentModal } = useGlobalModals();
  const [search, setSearch] = useState('');

  const setOpen = (value: boolean) => {
    if (!value) {
      handleCloseModal({ preventScrollReset: true });
    } else {
      handleOpenModal('search');
    }
  };

  const isSearchModalOpen = currentModal === 'search';

  const { fetchPosts, posts, setPosts, setCurrentPage } = usePaginatedPosts({
    defaultPosts: [],
    enabled: isSearchModalOpen,
    // @ts-expect-error
    pagination: {
      per_page: DEFAULT_POSTS_PER_PAGE,
    },
  });

  const results: SearchResult[] = posts.map((post) => ({
    id: post.id,
    title: post.web_title,
    description: post.web_subtitle,
    pathname: `/p/${post.slug}`,
  }));

  const handleSearchChange = (query: string) => {
    setCurrentPage(0);
    setSearch(query);
    setPosts([]);
    fetchPosts(query);
  };

  useEffect(() => {
    if (isSearchModalOpen) {
      setCurrentPage(0);
      setSearch('');
      setPosts([]);
      fetchPosts();
    }
  }, [isSearchModalOpen]);

  return (
    <ClientOnly fallback={null}>
      {() => (
        <SearchModalElement
          results={results}
          open={isSearchModalOpen}
          setOpen={setOpen}
          search={search}
          setSearch={handleSearchChange}
        />
      )}
    </ClientOnly>
  );
};

export default SearchModal;
